import moment from 'moment'
import React, {useEffect, useRef, useState} from 'react'
import Chart from 'react-apexcharts'
import {TextboxWithLabel} from '../formComponents/TextboxWithLabel'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {getPatientUsage, postUserCigaretteUsage} from '../../../Adaptor/TUBSIS'
import {getPatientUsageOutput} from '../../../Adaptor/TUBSIS/controllers/UserCigaretteUsage/models/patientUsageModels'
import {ApexOptions} from 'apexcharts'
import {type} from 'os'

type Props = {
  title?: string
  options: ApexOptions
  series: {
    name: string
    data: number[]
  }[]
  type:
    | 'area'
    | 'line'
    | 'bar'
    | 'histogram'
    | 'pie'
    | 'donut'
    | 'radialBar'
    | 'scatter'
    | 'bubble'
    | 'heatmap'
    | 'treemap'
    | 'boxPlot'
    | 'candlestick'
    | 'radar'
    | 'polarArea'
    | 'rangeBar'
    | undefined
}
const StackedGraph: React.FC<Props> = ({type, series, title, options}) => {
  return (
    <>
      <div className='col-xl-6'>
        <div className='card'>
          <div className='card-body'>
            {/* <h4>{title}</h4> */}
            {/* <div>
              <Chart type={type} height={200} {...options} />
            </div> */}
            <div id='chart'>
              <Chart options={options} series={series} type={type} height={350} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StackedGraph
